<div class="row kt-pagination">
    <div class="col-sm-12 col-md-5">
        <ngb-pagination aria-label="Table pages" [collectionSize]="total" [(page)]="page" [pageSize]="pageSize"
            (pageChange)="onPageChanged($event)" [maxSize]="6" [rotate]="true"></ngb-pagination>
    </div>
    <div class="col-sm-12 col-md-7 dataTables_length kt-align-right">
        <label class="m-3">
            <select aria-label="Rows per page" class="custom-pagination-select" style="width: auto" name="pageSize" [(ngModel)]="pageSize"
                (ngModelChange)="onPageSizeChanged($event)">
                <option *ngFor="let pageValue of paginationOptions" [ngValue]="pageValue">{{pageValue}}</option>
            </select>
            &nbsp;
            <span role="status" aria-live="polite">Page {{page}} of {{totalNoOfPages}} ({{total}} items)</span>
        </label>
    </div>
</div>
